var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-data-table',{attrs:{"headers":_vm.headers,"data":_vm.sellerSales,"buttons":_vm.buttons,"items-per-page":10,"filter-fields":_vm.filterFields,"filter-data":_vm.filter,"tableActions":_vm.tableActions,"filter-title":"Filtrer les ventes vendeurs"},on:{"filter":_vm.toFilter,"reset":_vm.resetFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }